import { APP } from '../tokens';

const F = APP.fontFamily;

interface ReviewPanelActionsProps {
  onAcceptAll: () => void;
  onDismissAll: () => void;
  hasRemaining: boolean;
}

export default function ReviewPanelActions({ onAcceptAll, onDismissAll, hasRemaining }: ReviewPanelActionsProps) {
  if (!hasRemaining) return null;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        paddingBlock: 12,
        paddingInline: 16,
        gap: 8,
        borderTop: `1px solid ${APP.borderReviewCardDefault}`,
      }}
    >
      <button
        type="button"
        className="btn-hover"
        onClick={onAcceptAll}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: '0%',
          borderRadius: 6,
          paddingBlock: 8,
          backgroundColor: APP.textDark,
          border: 'none',
          cursor: 'pointer',
          fontFamily: F,
          fontSize: 12,
          fontWeight: 500,
          color: '#FDFCFB',
          lineHeight: '16px',
        }}
      >
        Accept all remaining
      </button>
      <button
        type="button"
        className="btn-hover"
        onClick={onDismissAll}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 6,
          paddingBlock: 8,
          paddingInline: 14,
          backgroundColor: '#FDFCFB',
          border: `1px solid ${APP.borderReviewCardDefault}`,
          cursor: 'pointer',
          fontFamily: F,
          fontSize: 12,
          fontWeight: 500,
          color: APP.textReviewInfo,
          lineHeight: '16px',
        }}
      >
        Dismiss All
      </button>
    </div>
  );
}
